'use strict';

module.exports = {
  TEAM: 'teamChallenge',
  GROUP: 'group',
  SOLO: 'solo',
  CHARITY: 'charity',
  INSTANT_WIN: 'instantWin',
  RACE: 'race',
  PROGRAM: 'program',
};
